var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1.6","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},[React.createElement("path",{"strokeLinejoin":"round","d":"M8 1l4.243 4.243L8 9.485","key":0}),React.createElement("path",{"d":"M1 5.243h10.454","key":1})]));
}

Arrow.defaultProps = {"viewBox":"0 0 14 11","width":"14","height":"11"};

module.exports = Arrow;

Arrow.default = Arrow;
